import { gql } from '@apollo/client';

export const CREATE_RATED_QUESTION = gql`
    mutation createRatedQuestion($input: RatedQuestionInput!) {
        createRatedQuestion(input: $input) {
            _id
        }
    }
`;
